<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="广告位编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              disabled
              placeholder="请输入广告位编号"
              v-decorator="[
          'id',
          {rules: [],initialValue:info.id}
        ]"
              readonly
            ></a-input>
          </a-form-item>
          <a-form-item label="广告位名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入广告位名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入广告位名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="尺寸" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入广告尺寸"
              v-decorator="[
          'size',
          {rules: [],initialValue:info.size}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="状态" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-switch
              v-model="info.status"
              v-decorator="[
          'status',
          {rules: []}
        ]"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        status: true
      },
      isloading: false,
      loadingTip: "加载中..."
    };
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if (this.infos.id) {
        //编辑
        this.getInfo();
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**数据回显 */
    getInfo() {
      // this.info = this.infos;
      this.isloading = true;
      this.$api.adzone
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;

            this.info.status = this.$commen.changeIntBoolean(res.data.status);
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (that.infos.id) {
            //编辑
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.adzone
              .update(
                this.info.id,
                values.name,
                values.size,
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.adzone
              .save(
                values.name,
                values.size,
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.anticon-plus-circle {
  margin-left: 10px !important;
  cursor: pointer;
}
.anticon-minus-circle {
  margin-left: 10px !important;
  cursor: pointer;
}
</style>